export default class LangComponent {
    constructor() {
        LangComponent.openLangModal()
        LangComponent.closeLangModal()
        LangComponent.detectAndOpenLangModal()
    }

    static openLangModal() {
        $('[data-element="toggle-lang-witcher"]').on('click', () => {
            $('#dialog-lang-switcher').show()
        })
    }

    static closeLangModal() {
        $('#dialog-lang-switcher a, #dialog-lang-switcher .close').on('click', () => {
            LangComponent.setCookie('iris_language_choose', true, 30)
            $('#dialog-lang-switcher').hide()
        })
    }

    static async detectAndOpenLangModal() {
        try {
            const response = await fetch('https://ipapi.co/json/', {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                signal: AbortSignal.timeout(5000)
            })

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`)
            }

            const data = await response.json()

            if (!data.country_code) {
                throw new Error('Invalid API response: missing country_code')
            }

            LangComponent.processLanguageDetection(data)

        } catch (error) {
            console.error('Erreur lors de la récupération des données IP:', error.message)
            LangComponent.handleApiError(error)
        }
    }

    static processLanguageDetection(data) {
        const currentLang = $('html').attr('lang')
        if (!currentLang) {
            console.warn('Aucune langue détectée sur la page')
            return
        }

        const currentLangCode = currentLang.slice(-2).toLowerCase()
        const userLang = data.country_code.toLowerCase()
        const cookie = LangComponent.getCookie('iris_language_choose')

        // console.log(`Pays utilisateur: ${userLang} | Langue de la page: ${currentLangCode} | Cookie: ${cookie}`)

        if (userLang !== currentLangCode && cookie !== 'true') {
            $('#dialog-lang-switcher').show()
            LangComponent.editModalContent(userLang)
        }
    }

    static editModalContent(userLang) {
        let userLangSlug = LangComponent.getSlugByCode(userLang)
        let $suggestionLangElement = $('#dialog-lang-switcher .dialog-lang-switcher__list').find(`li[data-lang-slug="${userLangSlug}"]`).html()
        $('#dialog-lang-switcher .dialog-lang-switcher__text').append($suggestionLangElement)
    }

    static getSlugByCode(langCode) {
        let langName = ''
        const langListData = $('#dialog-lang-switcher').find('ul').data('lang-list')

        for(const code in langListData) {
            let shortCode = code.slice(-2).toLowerCase()
            if(shortCode === langCode) {
                langName = langListData[code].slug
            }
        }

        return langName;
    }

    static handleApiError(error) {
        if (error.name === 'AbortError') {
            console.log('Requête annulée par timeout')
        } else if (error.name === 'NetworkError') {
            console.log('Erreur réseau lors de la détection de la langue')
        } else {
            console.log('Erreur générale lors de la détection de la langue:', error.message)
        }
    }

    static setCookie(cname, cvalue, exdays) {
        const d = new Date()
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
        const expires = `expires=${d.toUTCString()}`
        document.cookie = `${cname}=${cvalue};${expires};path=/`
    }

    static getCookie(cname) {
        const name = `${cname}=`
        const decodedCookie = decodeURIComponent(document.cookie)
        const ca = decodedCookie.split(';')
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i]
            while (c.charAt(0) === ' ') {
                c = c.substring(1)
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length)
            }
        }
        return ''
    }
}